import { Component } from '@angular/core';

@Component({
  selector: 'fastnet',
  template: require('./app.component.html')
})

export class AppComponent {}



/** WEBPACK FOOTER **
 ** ./~/angular2-router-loader/src!./~/angular2-template-loader!./src/app/app.component.ts
 **/